import { render, staticRenderFns } from "./SupplyMaterialForm.vue?vue&type=template&id=271b7292&scoped=true"
import script from "./SupplyMaterialForm.vue?vue&type=script&lang=ts"
export * from "./SupplyMaterialForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b7292",
  null
  
)

export default component.exports